import React from "react";
import { NavLink } from "react-router-dom";

const companyNavItems = [
  { to: "/company/dashboard", label: "Dashboard", icon: "D" },
  { to: "/company/upload-resumes", label: "Upload Resumes", icon: "U" },
  { to: "/company/uploaded-resumes", label: "Resume Library", icon: "R" },
  { to: "/company/jobs", label: "Post Job", icon: "+" },
  { to: "/company/sub-companies", label: "Sub Companies", icon: "C" },
  { to: "/company/employees", label: "Recruiter Management", icon: "R" },
  { to: "/company/recruiter-performance", label: "Recruiter Performance", icon: "P" },
  { to: "/company/followup-report", label: "Followup Report", icon: "F" },
];

const subCompanyNavItems = [
  { to: "/company/client-dashboard", label: "Dashboard", icon: "D" },
];

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export default function CompanyLayout({ title, description, headerAction, children }) {
  const user = getStoredUser();
  const isSubCompany = user?.user_type === "sub_company" || user?.role === "sub_company";
  const navItems = isSubCompany ? subCompanyNavItems : companyNavItems;

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50">
      <div className="sticky top-16 z-30 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="text-xl text-emerald-600">C</span>
            <div className="flex items-center gap-3">
              <h1 className="text-lg font-semibold text-gray-900">{isSubCompany ? "Sub Company Panel" : "Company Panel"}</h1>
              <span className="rounded bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">v1.0</span>
            </div>
          </div>
          <NavLink
            to={isSubCompany ? "/company/client-dashboard" : "/company/dashboard"}
            className="rounded-md bg-gray-50 px-3 py-1.5 text-xs text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
          >
            Back to Dashboard
          </NavLink>
        </div>
      </div>

      <div className="border-b border-gray-200 bg-white">
        <div className="overflow-x-auto px-4 sm:px-6">
          <div className="flex gap-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "border-emerald-500 text-emerald-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`
                }
              >
                <span>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="px-4 py-8">
        <div className="w-full">
          <div className="mb-4 rounded-lg border border-gray-200 bg-white px-4 py-4 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
                {description ? (
                  <p className="mt-2 text-sm text-slate-600">{description}</p>
                ) : null}
              </div>
              {headerAction ? <div className="shrink-0">{headerAction}</div> : null}
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}